import { reducerNames } from 'store/constants';

export const getResourcesState = (state) => state[reducerNames.RESOURCES].resources;

export const getMockResourceDetailsState = (state) => state[reducerNames.RESOURCES].mockResourceDetails;

export const getResourceDetailsState = (state) => state[reducerNames.RESOURCES].resourceDetails;